module.exports = __webpack_public_path__ + "img/kato.0609ae1f.jpg";